import { defineMessages } from 'react-intl';

export default defineMessages({
    searchPolicyPageTitle: {
        id: 'ax.fnol.policysearch.page.title',
        defaultMessage: 'Search and select policy'
    },
    policyNumberInput: {
        id: 'ax.fnol.policysearch.forminput.policyNumberInput',
        defaultMessage: '# policy'
    },
    companyNameInput: {
        id: 'ax.fnol.policysearch.forminput.companyNameInput',
        defaultMessage: 'Company name'
    },
    nameInput: {
        id: 'ax.fnol.policysearch.forminput.nameInput',
        defaultMessage: 'Name'
    },
    paternalSurnameInput: {
        id: 'ax.fnol.policysearch.forminput.paternalSurnameInput',
        defaultMessage: 'Paternal surname'
    },
    maternalSurnameInput: {
        id: 'ax.fnol.policysearch.forminput.maternalSurnameInput',
        defaultMessage: 'Maternal surname'
    },
    origenSelect: {
        id: 'ax.fnol.policysearch.forminput.origenSelect',
        defaultMessage: '-- Choose source --'
    },
    clauseNumberInput: {
        id: 'ax.fnol.policysearch.forminput.clauseNumberInput',
        defaultMessage: '# clause'
    },
    stateSelect: {
        id: 'ax.fnol.policysearch.forminput.stateSelect',
        defaultMessage: '-- Choose state --'
    },
    vin: {
        id: 'ax.fnol.policysearch.forminput.vinInput',
        defaultMessage: 'Vin'
    },
    licensePlate: {
        id: 'ax.fnol.policysearch.forminput.licensePlateInput',
        defaultMessage: 'license plate'
    },
    searchPoliciesButton: {
        id: 'ax.fnol.policysearch.formbutton.searchPoliciesButton',
        defaultMessage: 'Search'
    },
    resetFormButton: {
        id: 'ax.fnol.policysearch.formbutton.resetFormButton',
        defaultMessage: 'Reset'
    },
    noResults: {
        id: 'ax.fnol.policysearch.noResults',
        defaultMessage: 'No results'
    },
    noResultsMessage: {
        id: 'ax.fnol.policysearch.noResultsMessage',
        defaultMessage: 'No results were found using the search criteria provided. Please check the information!'
    },
    error: {
        id: 'ax.fnol.policysearch.error',
        defaultMessage: 'No search criteria'
    },
    errorMessage: {
        id: 'ax.fnol.policysearch.errorMessage',
        defaultMessage: 'Please enter more criteria for the search!'
    },
    info: {
        id: 'ax.fnol.policysearch.inlinenotification.info',
        defaultMessage: 'Attention:'
    },
    infoMessage: {
        id: 'ax.fnol.policysearch.inlinenotification.infoMessage',
        defaultMessage: 'The status of the policy is shown as of today. Enter the date of the claim and proceed to step 2 to validate the status as of the date the claim occurred'
    },
    lossDateInput: {
        id: 'ax.fnol.policysearch.forminput.lossDateInput',
        defaultMessage: 'Loss date'
    },
    cancelButton: {
        id: 'ax.fnol.policysearch.formbutton.cancel',
        defaultMessage: 'Cancel'
    },
    nextStepButton: {
        id: 'ax.fnol.policysearch.formbutton.confirmAndContinue',
        defaultMessage: 'Confirm and continue'
    },
    select: {
        id: 'ax.fnol.policyresult.selectButton.select',
        defaultMessage: 'Select'
    },
    deselect: {
        id: 'ax.fnol.policyresult.selectButton.deselect',
        defaultMessage: 'Deselect'
    },
    policyNumberInput: {
        id: 'ax.fnol.policyresult.policyNumberInput',
        defaultMessage: 'Policy number:'
    },
    effectiveDateInput: {
        id: 'ax.fnol.policyresult.effectiveDateInput',
        defaultMessage: 'Effective date:'
    },
    policyStatusInput: {
        id: 'ax.fnol.policyresult.policyStatusInput',
        defaultMessage: 'Policy status:'
    },
    insuredInput: {
        id: 'ax.fnol.policyresult.insuredInput',
        defaultMessage: 'Insured:'
    },
    expirationDateInput: {
        id: 'ax.fnol.policyresult.expirationDateInput',
        defaultMessage: 'Expiration date:'
    },
    policyCollectionStatusInput: {
        id: 'ax.fnol.policyresult.policyCollectionStatusInput',
        defaultMessage: 'Policy collection status:'
    },
    clauseNumberInput: {
        id: 'ax.fnol.policyresult.clauseNumberInput',
        defaultMessage: 'Clause number:'
    },
    addressLine1Input: {
        id: 'ax.fnol.policyresult.addressLine1Input',
        defaultMessage: 'Address:'
    },
    vehicleDescription: {
        id: 'ax.fnol.policyresult.vehicleDescription',
        defaultMessage: 'Make:'
    },
    vinInput: {
        id: 'ax.fnol.policyresult.vinInput',
        defaultMessage: 'Vin:'
    },
    licensePlateInput: {
        id: 'ax.fnol.policyresult.licensePlateInput',
        defaultMessage: 'License plate:'
    }
});
